export class AuditLogEntry {
    Area: string;
    Action: string;
    LogObject: object;
}
